define('GameDayCore/GDModel/ValueObjects/Gamecenter/StatcastBatterAverages',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(StatcastBatterAverages);

	function StatcastBatterAverages($data) {
		var vo = VO.ensureVO(this, StatcastBatterAverages),
			data = $data;

			vo.players = [];
			if (data.statcast_hit_averages.queryResults.row) {
				if(data.statcast_hit_averages.queryResults.row instanceof Array) {
					data.statcast_hit_averages.queryResults.row.forEach(function(player) {
						// Round some values
						player.avg_launch_speed = parseFloat(player.avg_launch_speed).toFixed(1);
						player.avg_distance = parseFloat(player.avg_distance).toFixed(1);
						player.avg_launch_angle = parseFloat(player.avg_launch_angle).toFixed(1);

						vo.players[player.batter_id] = player;
					});
				} else {
					data.statcast_hit_averages.queryResults.row.avg_launch_speed = parseFloat(data.statcast_hit_averages.queryResults.row.avg_launch_speed).toFixed(1);
					data.statcast_hit_averages.queryResults.row.avg_distance = parseFloat(data.statcast_hit_averages.queryResults.row.avg_distance).toFixed(1);
					data.statcast_hit_averages.queryResults.row.avg_launch_angle = parseFloat(data.statcast_hit_averages.queryResults.row.avg_launch_angle).toFixed(1);

					vo.players[data.statcast_hit_averages.queryResults.row.batter_id] = data.statcast_hit_averages.queryResults.row;
				}
			}
	}

	return StatcastBatterAverages;
});
